export const makingOverpaymentsPage = {
  heading: 'overpayments-page-heading',
  sectionHeading: 'overpayments-section-heading',
  sectionBody: 'overpayments-section-body',

  payByChequeAccordion: 'overpayments-pay-by-cheque-accordion',
  internationalPaymentsAccordion: 'overpayments-international-payments-accordion'
};
